import styles from './InnerMargin.module.scss';

import type { FC, ReactNode } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

export type Props = {
  type: 'span' | 'div';
  align: 'default' | 'center';
  children?: ReactNode;
};

export type AlignProps = {
  align: 'default' | 'center';
  children?: ReactNode;
};

export const InnerMargin: FC<AlignProps> = ({ children, align }) => {
  switch (align) {
    case 'default':
      return <div className={styles['default-div']}>{children}</div>;
    case 'center':
      return <div className={styles['center-div']}>{children}</div>;
    default:
      return assertNever(align);
  }
};
